module.exports = __webpack_public_path__ + "static/media/team.1e237216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/team.png
// module id = 1103
// module chunks = 0